/* eslint-disable react-hooks/exhaustive-deps */
import { XGrid } from 'app/components/Common/XGrid/XGrid';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { candidateDetailActions } from '../../../Profile/CandidateDetails.redux';
import { candidateEmployementSelection, selectReferences } from '../../../Profile/CandidateDetails.selector';
import { CommonPopUpforWorkAndEducation } from '../../Common/CommonPopUpforWorkAndEducation';
import { useParams } from 'react-router-dom';
import { useReadOnly, userRoles } from 'oidc/userRoles';
import { useTranslation } from 'react-i18next';
import { ILookupState } from 'store/redux-store/lookup/initialState';
import { lookupSelector } from 'store/redux-store/lookup/lookup.selectors';
import { missingField } from 'app/constants';
import AddIcon from '@mui/icons-material/Add';
import { RequestReferenceModal } from '../RequestReferenceModal';
import {
  ff_candidate_ui_manage_references,
  ff_ui_candidate_manage_EquipmentProcedure,
} from 'app/constants/FeatureFlags/Candidate/Keys';
import { useDecision } from '@optimizely/react-sdk';
import { AddReferenceModal } from '../../Common/AddReferenceModal';
import { Authorized } from 'oidc/userHelper';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { WorkExperienceDialog } from './WorkExperienceDialog';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { makeStyles } from 'tss-react/mui';
import { usePromiseTracker } from 'react-promise-tracker';
import { ReferencesStatus } from 'app/enums/WorkHistory';
import { GridCallbackDetails, GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid';
import { selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { RootState } from 'types';
import { userDevicePreferenceActions } from 'oidc/UserDevicePreference/userPreference.redux';
import { GridColumns as XGridColumns } from '@mui/x-data-grid-pro';
import _ from 'lodash';
import { selectUserPreference } from 'oidc/UserDevicePreference/userPreference.selectors';
import { GridColumns } from 'app/models/GlobalSearch/GlobalSearch';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { getWorkExperienceReadOnlyColumns } from './v2/GetColumns';
import { EditExperienceWrapper } from '@AMIEWEB/Candidate/CandidateProfile/WorkExperience/Edit/EditExperienceWrapper';
import moment from 'moment';

interface WorkExperienceGridProps {
  onEdit?: (row) => void;
  onDelete?: (params, event) => void;
  rows: any[];
  handleBack?: (event) => void;
}

enum referenceStatus {
  VERIFIED = 'Verified',
  APPROVED = 'Approved',
  UNAPPROVED = 'Unapproved',
}

const useWorkExperienceGridStyles = makeStyles()(() => ({
  root: {
    color: '#888888',
    '&:hover': { color: '#106FB9' },
  },
  disabled: {
    color: '#CECECE',
  },
}));

export const workExperienceColumnVisibility = {
  facilityName: true,
  country: true,
  city: true,
  state: true,
  zip: true,
  disciplineAbbr: true,
  specialtyAbbr: true,
  startedOn: true,
  currentlyEmployed: true,
  endedOn: true,
  reasonForLeaving: true,
  position: true,
  unit: true,
  numberOfBedsInFacility: true,
  travelCompany: true,
  equipmentProcedures: true,
  isSupervisor: true,
  isTeletherapy: true,
  staffingAgency: true,
  isTeachingHospital: true,
};

export const WorkExperienceGrid = ({ onEdit, onDelete, rows, handleBack }: WorkExperienceGridProps) => {
  const { classes } = useWorkExperienceGridStyles();
  const dispatch = useDispatch();
  // all the references in the database
  const totalReferences = useSelector(selectReferences);
  const [showAddReference] = useDecision(ff_candidate_ui_manage_references);
  const [showEquipmentProcedure] = useDecision(ff_ui_candidate_manage_EquipmentProcedure);
  const user = useSelector(selectUser);
  const [workExperienceData, setWorkExperienceData] = useState<any>([]);
  const { userInfo } = useSelector(selectUser);
  const [openAddPop, setOpenAddPop] = useState<boolean>(false);
  const [openAddReference, setOpenAddReference] = useState<boolean>(false);
  const [addReferenceAuthorized, setAddReferenceAuthorized] = useState<boolean>(false);
  const selMasterCopy: ILookupState = useSelector(lookupSelector);
  const selReferences = useSelector(selectReferences);
  const [columns, setColumns] = React.useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [updated, setUpdated] = useState(false);
  const { travelerId: candidateId, brandId } = useParams<{ travelerId: string; brandId: string }>();
  const { readOnly } = useReadOnly();
  const { t } = useTranslation();
  const apiRef = useGridApiRef();
  const [openRequestPop, setOpenRequestPop] = useState<boolean>(false);
  const [hasPermission, setHasPermission] = useState<boolean>(false);
  const [defaultSortModel, setDefaultSortModel] = React.useState<any[]>([]);
  const [currentSortModel, setCurrentSortModel] = React.useState<any[]>([]);
  const [currentColumnVisibilityModel, setCurrentColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(workExperienceColumnVisibility),
  );
  const [defaultColumnVisibilityModel, setDefaultColumnVisibilityModel] = React.useState<any>(
    _.cloneDeep(workExperienceColumnVisibility),
  );

  const gridTag = 'CandidateWorkExperience';
  const gridState = useSelector(selectGridState);
  const userPreference = useSelector(selectUserPreference);
  const gridPreferences = useSelector((state: RootState) => {
    return state.userPreferenceData.userGridPreferences.find(item => item.id === gridTag);
  });
  const [isWorkExpDeleteOpen, setWorkExpExpDeleteOpen] = useState(false);
  const workExperienceId = useRef<any>(null);
  const { promiseInProgress: deleteWorkExperienceTracker } = usePromiseTracker({
    area: 'delete-work-exp-record',
    delay: 0,
  });
  const employmentHistory = useSelector(candidateEmployementSelection);

  const country: any[] = [];
  selMasterCopy?.countries?.map(x => {
    country.push({ label: x.Description, id: x.ID });
  });

  React.useEffect(() => {
    setColumns(
      getWorkExperienceReadOnlyColumns(t, classes, handleDisableDeleteBtn, onWorkExpDelete, showEquipmentProcedure),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (updated) {
      setLoading(false);
      setUpdated(false);
      dispatch(
        globalActions.setSnackBar({
          message: t('candidate.workExperience.snackbar.updateWorkExperienceDetails'),
          severity: 'success',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updated]);

  /**
   * Method to delete work experience record
   * @param params
   */
  const onWorkExpDelete = (params: GridRenderCellParams) => {
    workExperienceId.current = params?.row?.workHistoryId;
    setWorkExpExpDeleteOpen(true);
  };

  // const fetchDetails = async () => {
  //   setLoading(true);
  //   if (candidateId && brandId) {
  //     await getCandidateById(candidateId, brandId).then(async candidateRes => {
  //       dispatch(candidateDetailActions.setCredentials(candidateRes.credential));
  //       setUpdated(true);
  //     });
  //   }
  // };

  useEffect(() => {
    const data: any[] = [];
    employmentHistory.map((x, idx) => {
      const state = x.location.state;
      const country = x.location.country;
      const locationData = {
        address1: x.location.address1,
        address2: x.location.address2,
        city: !isTimeOff(x) ? x.location.city : null,
        state: selMasterCopy?.states?.find(x => x.ID == state)?.Description ?? x.location.stateProvinceID,
        stateProvinceID: selMasterCopy?.states?.find(x => x.ID == state)?.ID ?? x.location.stateProvinceID,
        country: x.location.country,
        countryId: selMasterCopy?.countries?.find(x => x.Description == country)?.ID,
        zip: x.location.zip,
      };

      data.push({
        ...x,
        ...locationData,
        id: idx,
        position: x.position,
        unit: x.unit,
        numberOfBedsInFacility: x.numberOfBedsInFacility,
        travelCompany: x.travelCompany,
        reasonForLeaving: x.reasonForLeaving,
        staffingAgency: x.staffingAgency == 'Y' ? true : false,
        isTeachingHospital: x.isTeachingHospital == 'Y' ? true : false,
        timeStamp: x?.timeStamp,
        referenceData: selReferences?.items?.filter(item => item.workHistoryID === x.workHistoryId),
        equipmentProcedures: x?.equipmentProcedures?.length > 0 ? x?.equipmentProcedures : missingField,
        verifiedEMPVReferenceCount: x?.verifiedEMPVReferenceCount || 0,
      });
    });
    setWorkExperienceData(data);
  }, [employmentHistory]);

  useEffect(() => {
    if (
      Authorized(
        [
          userRoles.clinical_Manager,
          userRoles.clinical_Director,
          userRoles.clinical_ReviewAnalyst,
          userRoles.clinical_QualificationsSpecialist,
          userRoles.recruitment_Leadership,
          userRoles.recruitment_TeamMember,
        ],
        userInfo,
      )
    ) {
      setAddReferenceAuthorized(true);
    }
  }, [userInfo]);

  useEffect(() => {
    if (deleteWorkExperienceTracker) {
      setWorkExpExpDeleteOpen(false);
    }
  }, [deleteWorkExperienceTracker]);

  const isTimeOff = data => {
    return data?.facilityName === t('candidate.empHistoryGrid.timeOff');
  };

  /**
   *  Method to handle delete button disable validation
   * @param params
   */
  const handleDisableDeleteBtn = (params: GridRenderCellParams) => {
    const currentWorkHistoryRecord = totalReferences?.items.filter(
      item => item.workHistoryID === params?.row?.workHistoryId,
    );
    const isDisabled = currentWorkHistoryRecord?.some(currentItem =>
      [ReferencesStatus.VERIFIED, ReferencesStatus.APPROVED, ReferencesStatus.UNAPPROVED].includes(
        currentItem.statusID,
      ),
    );
    return isDisabled || params?.row?.placementID;
  };

  const [defaultColumns, setDefaultColumns] = React.useState<any>(
    getWorkExperienceReadOnlyColumns(t, classes, handleDisableDeleteBtn, onWorkExpDelete, showEquipmentProcedure),
  );

  const [currentColumns, setCurrentColumns] = React.useState<any>(
    getWorkExperienceReadOnlyColumns(t, classes, handleDisableDeleteBtn, onWorkExpDelete, showEquipmentProcedure),
  );

  const saveSortModel = React.useCallback(
    sortModel => {
      const sortedColumn =
        sortModel?.length > 0
          ? {
              column: sortModel[0]?.field,
              direction: sortModel[0]?.sort,
            }
          : undefined;
      if (!_.isEqual(sortedColumn, gridState?.sortedColumn)) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            sortedColumn: sortedColumn,
          },
        };
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [dispatch, gridPreferences?.value, gridState?.sortedColumn],
  );

  const savePreferences = React.useCallback(
    ({
      field,
      columns: gridColumns,
      visibilityModel,
    }: {
      field?: string;
      columns: XGridColumns;
      visibilityModel: GridColumnVisibilityModel;
    }) => {
      if (!currentColumns || currentColumns?.length === 0 || !userPreference?.loaded) return;
      const currentGridColumns = new GridColumns(gridColumns).columns;

      if (currentGridColumns && currentGridColumns?.length > 0 && currentGridColumns[0]?.field === '__check__')
        currentGridColumns.shift();

      const comparableColumns = new GridColumns(
        gridPreferences?.value?.columns,
        gridPreferences?.value?.columnVisibilityModel,
      );
      const columnsEqual = comparableColumns.isEqual(currentGridColumns);
      const visibilityEqual = comparableColumns.isVisibilityModelEqual(visibilityModel);

      if (!columnsEqual || !visibilityEqual) {
        const preferenceData = {
          id: gridTag,
          value: {
            ...(gridPreferences?.value || {}),
            columns: currentGridColumns,
            columnVisibilityModel: visibilityModel,
          },
        };
        dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
      }
    },
    [currentColumns, userPreference?.loaded, defaultColumns?.length, gridPreferences?.value, dispatch],
  );

  const getColumnPreferences = (cols: any[]) => {
    try {
      const columnPreferences = gridPreferences?.value;
      if (columnPreferences && columnPreferences?.columns) {
        const newColumns = cols.map(column => {
          const foundIndex = columnPreferences?.columns.findIndex(item => item?.field === column?.field);
          if (foundIndex !== -1) {
            return {
              ...column,
              ...columnPreferences?.columns[foundIndex],
            };
          } else {
            return column;
          }
        });
        return newColumns.sort((a, b) => {
          return (
            columnPreferences?.columns.findIndex(i => i.field === a.field) -
            columnPreferences?.columns.findIndex(i => i.field === b.field)
          );
        });
      }
      return cols;
    } catch (err) {
      return cols;
    }
  };

  const getVisibilityPreferences = (cols: any) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.columnVisibilityModel) {
      return columnPreferences?.columnVisibilityModel;
    }
    return cols;
  };

  const getSortModelPreferences = (sortModel: any[]) => {
    const columnPreferences = gridPreferences?.value;
    if (columnPreferences && columnPreferences?.sortedColumn) {
      const preferenceSortModel = columnPreferences?.sortedColumn;
      return [{ field: preferenceSortModel?.column, sort: preferenceSortModel?.direction }];
    }
    return sortModel;
  };

  const determineGridColumns = () => {
    const currentGridColumns = getColumnPreferences(defaultColumns);
    setCurrentColumns(currentGridColumns);
  };

  const determineVisibilityModel = () => {
    const currentVisibilityModel = getVisibilityPreferences(defaultColumnVisibilityModel);
    setCurrentColumnVisibilityModel(currentVisibilityModel);
  };
  const determineSortModel = () => {
    const currentGridSortModel = getSortModelPreferences(defaultSortModel);
    setCurrentSortModel(currentGridSortModel);
    if (
      !gridState?.sortedColumn ||
      (gridState?.sortedColumn &&
        (gridState?.sortedColumn?.column !== currentGridSortModel[0]?.field ||
          gridState?.sortedColumn?.direction !== currentGridSortModel[0]?.sort))
    ) {
      dispatch(
        gridStateActions.setSortedColumn({
          column: currentGridSortModel[0]?.field,
          direction: currentGridSortModel[0]?.sort,
        }),
      );
    }
  };

  React.useEffect(() => {
    if (userPreference?.loaded) {
      dispatch(gridStateActions.setGrid(gridTag));
      determineGridColumns();
      determineVisibilityModel();
      determineSortModel();
    }
  }, [userPreference?.loaded]);

  const handleNavigation = () => {
    setOpenAddPop(true);
  };
  const handleClose = () => {
    setOpenAddPop(false);
  };

  const handleRequestRefNavigation = () => {
    setOpenRequestPop(true);
  };

  const handleRequestRefClose = () => {
    setOpenRequestPop(false);
  };
  useEffect(() => {
    setHasPermission(
      Authorized(
        [
          userRoles.recruitment_TeamMember,
          userRoles.recruitment_Leadership,
          userRoles.clinical_Manager,
          userRoles.clinical_Director,
          userRoles.clinical_ReviewAnalyst,
          userRoles.clinical_QualificationsSpecialist,
        ],
        user.userInfo,
      ),
    );
  }, [user.userInfo]);

  const handleReferenceNavigation = () => {
    setOpenAddReference(true);
  };

  const handleCloseReference = () => {
    setOpenAddReference(false);
  };

  const handleBackClick = event => {
    dispatch(gridStateActions.setPageNumber(1));
    handleBack(event);
  };

  /**
   * Method to trigger delete work experience on clicking ok
   */
  const handleWorkExpDelete = () => {
    if (workExperienceId.current) {
      const experience = workExperienceData.find(item => item.workHistoryId === workExperienceId.current);
      let res;
      if (experience.facilityName === 'Personal Time Off') {
        res = {
          facilityName: experience.facilityName,
          country: '',
          city: '',
          zip: null,
          state: '',
          discipline: '',
          specialty: '',
          startedOn: experience.startedOn ? moment(experience.startedOn).format('YYYY-MM-DD') : '',
          endedOn: experience.endedOn ? moment(experience.startedOn).format('YYYY-MM-DD') : '',
          position: null,
          unit: null,
          numberOfBedsInFacility: null,
          travelCompany: null,
        };
      } else {
        res = {
          facilityName: experience.facilityName,
          country: experience.country,
          city: experience.city,
          zip: experience.zip,
          state: experience.state,
          discipline: experience.discipline,
          specialty: experience.specialty,
          startedOn: experience.startedOn ? moment(experience.startedOn).format('YYYY-MM-DD') : '',
          endedOn: experience.endedOn ? moment(experience.startedOn).format('YYYY-MM-DD') : '',
          position: experience.position,
          unit: experience.unit,
          numberOfBedsInFacility: experience.numberOfBedsInFacility,
          travelCompany: experience.travelCompany,
        };
      }
      dispatch(
        candidateDetailActions.deleteWorkExperienceRecord({
          workHistoryRecordId: workExperienceId.current,
          workExperienceList: workExperienceData,
          requestBody: res,
        }),
      );
    }
  };

  const onSortModelChanged = (model: GridSortModel, details: GridCallbackDetails) => {
    if (model?.length > 0) {
      saveSortModel(model);
    }
    setCurrentSortModel(model);
  };

  const SearchXGrid = React.useMemo(() => {
    return (
      <XGrid
        apiRef={apiRef}
        loading={loading}
        defaultColumns={defaultColumns}
        defaultColumnVisibilityModel={defaultColumnVisibilityModel}
        defaultSortModel={defaultSortModel}
        columns={currentColumns}
        columnVisibilityModel={currentColumnVisibilityModel}
        sortModel={currentSortModel}
        onSortModelChange={onSortModelChanged}
        rows={workExperienceData || []}
        title={t('candidate.workExperience.workExperienceGrid.gridTitle')}
        disableSelectionOnClick
        toolbarProps={{
          leftTitleAction: (
            <ArrowBackIcon
              onClick={handleBackClick}
              style={{ cursor: 'pointer', height: '20px', width: '20px', marginLeft: '-9px' }}
            />
          ),
          resetColumns: () => {
            setCurrentColumns(
              getWorkExperienceReadOnlyColumns(
                t,
                classes,
                handleDisableDeleteBtn,
                onWorkExpDelete,
                showEquipmentProcedure,
              ),
            );
            setCurrentColumnVisibilityModel(workExperienceColumnVisibility);
            setCurrentSortModel(defaultSortModel);
            const preferenceData = {
              id: gridTag,
              value: {
                ...(gridPreferences?.value || {}),
                columns: defaultColumns,
                columnVisibilityModel: defaultColumnVisibilityModel,
              },
            };
            dispatch(userDevicePreferenceActions.saveUserGridPreferenceAction(preferenceData));
            dispatch(
              globalActions.setSnackBar({
                message: 'Columns have been reset.',
                severity: 'success',
              }),
            );
          },
          leftActions: showAddReference.enabled
            ? [
                {
                  title: t('candidate.workExperience.workExperienceGrid.addAction'),
                  Icon: AddIcon,
                  onClick: handleNavigation,
                },
                {
                  title: t('candidate.referenceGrid.AddReference'),
                  Icon: AddIcon,
                  onClick: handleReferenceNavigation,
                  disabled: !hasPermission,
                },
                {
                  title: t('Request'),
                  Icon: PersonOutlineIcon,
                  onClick: handleRequestRefNavigation,
                },
              ]
            : [
                {
                  title: 'Work Experience',
                  Icon: AddIcon,
                  onClick: handleNavigation,
                },
              ],
        }}
        onColumnResizeStop={_columns => {
          savePreferences({
            field: undefined,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
          });
        }}
        onColumnOrderChange={(params, event, details, _columns) => {
          savePreferences({
            field: params.field,
            columns: _columns,
            visibilityModel: _.cloneDeep(currentColumnVisibilityModel ?? defaultColumnVisibilityModel),
          });
        }}
        onColumnVisibilityModelChange={(model, details) => {
          dispatch(gridStateActions.setColumnVisibilityModel(model));
          setCurrentColumnVisibilityModel(_.cloneDeep(model));
          savePreferences({
            field: undefined,
            columns: _.cloneDeep(apiRef?.current?.getAllColumns()),
            visibilityModel: _.cloneDeep(model),
          });
        }}
        initialState={{ pinnedColumns: { right: ['actions'] } }}
      />
    );
  }, [
    currentColumns,
    workExperienceData,
    defaultColumns?.length,
    loading,
    columns,
    gridPreferences?.value,
    dispatch,
    onSortModelChanged,
  ]);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {SearchXGrid}
        </Grid>
      </Grid>
      {openAddPop && <CommonPopUpforWorkAndEducation open={openAddPop} handleClose={handleClose} addType={`work`} />}
      {openAddReference && <AddReferenceModal open={openAddReference} handleClose={handleCloseReference} />}
      {<RequestReferenceModal open={openRequestPop} handleClose={handleRequestRefClose} />}
      {isWorkExpDeleteOpen && (
        <WorkExperienceDialog
          open={isWorkExpDeleteOpen}
          setDialogOpen={setWorkExpExpDeleteOpen}
          handleProceed={handleWorkExpDelete}
        />
      )}
      <EditExperienceWrapper />
    </>
  );
};
